import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { WhatIfSection } from './components/WhatIfSection';
import { PainSection } from './components/PainSection';
import { IdeasVsSystem } from './components/IdeasVsSystem';
import { HoursSection } from './components/HoursSection';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { OutcomesSection } from './components/OutcomesSection';
import { ObjectionSection } from './components/ObjectionSection';
import { TransformSection } from './components/TransformSection';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '1750632936154197';
interface AppProps {
  /** Show the rotating "someone just purchased" social-proof notifications. */
  showPurchasePopups?: boolean;
}
export function App({
  showPurchasePopups = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="851l3f0nuhxa">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="86mfn4mz60v5" />
      </noscript>

      <div className="flex min-h-full w-full flex-col items-center bg-cream-deep" data-id="element-2" data-mp="3bnutzeihuil4">
        <div className="w-full max-w-3xl bg-cream shadow-2xl" data-id="element-3" data-mp="3qc94mbm5jbc8">
          <main data-id="element-4" data-mp="3lkr6rwffdqvh">
            <Hero data-id="element-5" data-mp="3lk7mi92ayqea" />
            <WhatIfSection data-id="element-6" data-mp="3ljpigq9ef7vt" />
            <PainSection data-id="element-7" data-mp="3liedin47vu34" />
            <IdeasVsSystem data-id="element-8" data-mp="2xun2rnybrp3y" />
            <HoursSection data-id="element-9" data-mp="2xtv609szrlc3" />
            <SystemSection data-id="element-10" data-mp="2xtbvvf9l218m" />
            <ModulesSection data-id="element-11" data-mp="2xsk64l2o2xq9" />
            <BonusSection data-id="element-12" data-mp="2swlkh58q3ttj" />
            <OutcomesSection data-id="element-13" data-mp="2sv0m14jafqqe" />
            <ObjectionSection data-id="element-14" data-mp="2stzdb6pqvgbu" />
            <TransformSection data-id="element-15" data-mp="18d9c849dngr4" />
            <Pricing data-id="element-16" data-mp="18czo6m7w7jo2" />
            <Guarantee data-id="element-17" data-mp="18boj8j2po5vd" />
            <Testimonials data-id="element-18" data-mp="1d4hnz6y6je7g" />
            <FAQ data-id="element-19" data-mp="1d4rcsr7hnfbk" />
            <FinalCTA data-id="element-20" data-mp="1d59jkhrs1bxq" />
          </main>
          <Footer data-id="element-21" data-mp="1d6aywyftskl9" />
        </div>
      </div>

      {showPurchasePopups && <PurchasePopup data-id="element-22" data-mp="yh6dz9hnc29g" />}
    </>;
}